var React = require('react');

function Nebula (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.0165 30.0616C23.1788 30.0616 29.7957 23.4447 29.7957 15.2824C29.7957 7.12005 23.1788 0.503174 15.0165 0.503174C6.85418 0.503174 0.237305 7.12005 0.237305 15.2824C0.237305 23.4447 6.85418 30.0616 15.0165 30.0616ZM12.7427 18.4118L15.0165 25.4097L17.2903 18.4118H24.6484L18.6955 14.0868L20.9693 7.0888L15.0165 11.4138L9.06366 7.0888L11.3374 14.0868L5.3846 18.4118H12.7427Z","fill":"#3c3c3c"}));
}

Nebula.defaultProps = {"width":"30","height":"31","viewBox":"0 0 30 31","fill":"none"};

module.exports = Nebula;

Nebula.default = Nebula;
